import type { OptionsObject, SnackbarKey } from 'notistack';

type EnqueueSnackbar = (
  message: string,
  options?: OptionsObject,
) => SnackbarKey;

/** Extrae status HTTP de errores axios u objetos similares. */
export function getHttpStatus(error: unknown): number | undefined {
  if (error && typeof error === 'object' && 'response' in error) {
    const status = (error as { response?: { status?: number } }).response?.status;
    return typeof status === 'number' ? status : undefined;
  }
  return undefined;
}

/**
 * Mensaje de rechazos por permisos (403).
 * No usar para 401 (sesión); ese flujo sigue en el interceptor de api.ts.
 */
export function getPermissionDeniedMessage(error?: unknown): string {
  const status = getHttpStatus(error);
  if (status === 403) {
    const data = error && typeof error === 'object' && 'response' in error
      ? (error as { response?: { data?: { message?: string; title?: string } } }).response?.data
      : undefined;
    const serverMsg = data?.message || data?.title;
    if (serverMsg && typeof serverMsg === 'string' && !serverMsg.toLowerCase().includes('integration')) {
      return `No tenés permisos para realizar esta operación: ${serverMsg}`;
    }
    return 'No tenés permisos para realizar esta operación.';
  }
  return 'No tenés permisos para realizar esta operación.';
}

/** Muestra snackbar solo para 403; retorna true si fue un rechazo por permisos. */
export function notifyPermissionDenied(
  enqueueSnackbar: EnqueueSnackbar,
  error: unknown,
  options?: OptionsObject,
): boolean {
  if (getHttpStatus(error) !== 403) return false;
  enqueueSnackbar(getPermissionDeniedMessage(error), {
    variant: 'warning',
    preventDuplicate: true,
    ...options,
  });
  return true;
}
